import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';

export const ImprimirEstadoFinancieroPresupuesto = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [report, setReport] = useState('');
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCredito = useRef();
    const txtEjecucion = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtDesde.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Desde no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtDesde.current.focus();
        } else if (txtHasta.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Hasta no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtHasta.current.focus();
        }

        else if (sigue) {
            imprimirEstadoFinancieroPresupuesto(desde, hasta)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'desde') {
            setDesde(e.target.value);
        } else if (e.target.id === 'hasta') {
            setHasta(e.target.value);
        }
    };

    const onCheck = () => {

        if (txtCredito.current.checked) {
            setReport('Pres_IngrEdoEjecCredi');
            setActivo(false);
        } else if (txtEjecucion.current.checked) {
            if (espiritu === 0) {
                setReport('Pres_IngrEdoEjecOrd1');
            } else {
                setReport('Pres_IngrEdoEjecOrd');
            }
            setActivo(false);
        }

    }

    const imprimirEstadoFinancieroPresupuesto = (desde, hasta) => {

        var reporte = report;
        let desdec = "'" + moment.utc(desde).format('DD-MM-YYYY') + "'";
        let hastac = "'" + moment.utc(hasta).format('DD-MM-YYYY') + "'";
        let dia = hasta.substring(8, 10);
        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + dia + "&sql3=" + desdec + "&sql4=" + hastac, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtDesde.current.value = '';
        txtHasta.current.value = '';
        setActivo(true);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lx"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtHasta.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtDesde.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');

                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setHasta(fech);
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Estado Financiero de Ejecución del Presupuesto'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-6 mb-1 px-1 ml-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Desde:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesde} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desde" />
                                        </div>
                                    </div>

                                    <div className='col-sm-6 mb-1 px-1 ml-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHasta} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hasta" />
                                        </div>
                                    </div>

                                </div>
                                <div className='row m-0 px-0'>
                                    <div className="form-check col-md-6 ml-auto">
                                        <input className="form-check-input" ref={txtCredito} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Crédito Adicional
                                        </label>
                                    </div>
                                    <div className="form-check col-md-5 ml-auto">
                                        <input className="form-check-input" ref={txtEjecucion} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Solo Ejecución
                                        </label>
                                    </div>
                                </div>

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}